import { render, staticRenderFns } from "./IndustryPerson.vue?vue&type=template&id=79d9b7a5"
import script from "./IndustryPerson.vue?vue&type=script&lang=js"
export * from "./IndustryPerson.vue?vue&type=script&lang=js"
import style0 from "./IndustryPerson.vue?vue&type=style&index=0&id=79d9b7a5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports